
import { mapMutations, mapGetters, mapActions } from 'vuex';
import { defineComponent } from 'vue'

export default defineComponent({
  name: "NavBar",
  data() {
    return {
      showMenu: false
    }
  },
  methods: {
    toggleNavbar(): void{
      this.showMenu = !this.showMenu;
    },
    ...mapMutations('authModule', ['ToggleAuthLoginModal', 'ToggleAuthRegisterModal']),
    ...mapActions('authModule', ['logoutUser'])
  },
  computed: {
    ...mapGetters('authModule', ['loggedIn', 'getUsername'])
  }
})
